import produce, { Draft } from 'immer';
import { ActionType, getType } from 'typesafe-actions';
import * as actions from './actions';
import { UnitsState, initialUnitsState } from './model';

const unit = produce((draft: Draft<UnitsState>, action: ActionType<typeof actions>) => {
  switch (action.type) {
    case getType(actions.getUnitsList.request): {
      draft.list.loading = true;
      return draft;
    }
    case getType(actions.getUnitsList.success): {
      draft.list.loading = true;
      (draft.list.response as any) = action.payload;
      return draft;
    }
    case getType(actions.getUnitsList.failure): {
      draft.list.loading = false;
      draft.list.errors = action.payload;
      return draft;
    }
    case getType(actions.getUnitsDetails.request): {
      draft.details.loading = true;
      draft.details.response = undefined;
      draft.details.errors = undefined;
      return draft;
    }
    case getType(actions.getUnitsDetails.success): {
      draft.details.loading = true;
      draft.details.response = action.payload;
      return draft;
    }
    case getType(actions.getUnitsDetails.failure): {
      draft.details.loading = false;
      draft.details.errors = action.payload;
      return draft;
    }
    case getType(actions.createUnits.request): {
      draft.details.loading = true;
      draft.details.response = undefined;
      return draft;
    }
    case getType(actions.createUnits.success): {
      draft.create.loading = false;
      draft.create.response = action.payload;
      return draft;
    }
    case getType(actions.createUnits.failure): {
      draft.create.loading = false;
      draft.create.errors = action.payload;
      return draft;
    }
    case getType(actions.updateUnits.request): {
      draft.update.loading = true;
      draft.update.response = undefined;
      return draft;
    }
    case getType(actions.updateUnits.success): {
      draft.update.loading = false;
      draft.update.response = action.payload;
      return draft;
    }
    case getType(actions.updateUnits.failure): {
      draft.update.loading = false;
      draft.update.errors = action.payload;
      return draft;
    }
    case getType(actions.deleteUnits.request): {
      draft.delete.loading = true;
      draft.delete.response = undefined;
      return draft;
    }
    case getType(actions.deleteUnits.success): {
      draft.delete.loading = false;
      draft.delete.response = action.payload;
      return draft;
    }
    case getType(actions.deleteUnits.failure): {
      draft.delete.loading = false;
      draft.delete.errors = action.payload;
      return draft;
    }
    case getType(actions.bulkUnits.request): {
      draft.bulk.loading = true;
      draft.bulk.response = undefined;
      return draft;
    }
    case getType(actions.bulkUnits.success): {
      draft.bulk.loading = false;
      draft.bulk.response = action.payload;
      return draft;
    }
    case getType(actions.bulkUnits.failure): {
      draft.bulk.loading = false;
      draft.bulk.errors = action.payload;
      return draft;
    }
    case getType(actions.clearData): {
      if (action.payload) {
        draft[action.payload] = {};
      } else {
        draft = initialUnitsState;
      }
      return draft;
    }
    default: {
      return draft;
    }
  }
}, initialUnitsState);

export default unit;
